import {
    buttonClassName,
    pxToRem,
    labelClassName,
    pxArrayToRem,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const BoardDescriptionWrapper: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([25, 11, 30, 16]),
    color: theme.siteVariables.colors.charcoal[250],
});

export const MoreOrLess: StyleRule = ({ theme }) => ({
    width: pxToRem(268),
    color: theme.siteVariables.colors.grey[300],

    [`& .${buttonClassName}`]: {
        padding: pxArrayToRem([1, 0, 0, 0]),
        [`& > .${labelClassName}`]: {
            fontSize: pxToRem(14),
        },
    },
});

export const FlatDescription: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        margin: pxArrayToRem([50, 345, 0, 50]),
        fontSize: pxToRem(16),
    },
});

export const InviteButton: StyleRule = () => ({
    flexGrow: 1,
    margin: pxArrayToRem([1, 9, 0, 45]),
    width: pxToRem(32),
    height: pxToRem(32),
    borderRadius: '50%',
    [`& .${svgIconClassName}`]: {
        width: pxToRem(24),
        height: pxToRem(24),
        margin: pxArrayToRem([-2, 0, 0, -2]),
    },
});

export const MoreButton: StyleRule = () => ({
    margin: pxArrayToRem([1, 1, 0, 0]),
    width: pxToRem(32),
    height: pxToRem(32),
    borderRadius: '50%',
    [`& .${svgIconClassName}`]: {
        width: pxToRem(24),
        height: pxToRem(24),
    },
});
